export const trimJson = (obj) => {
  if (typeof obj === "string") {
    return obj.trim(); // Trim if it's a string
  } else if (Array.isArray(obj)) {
    return obj.map(trimJson); // Recursively trim each element in the array
  } else if (typeof obj === "object" && obj !== null) {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [key, trimJson(value)])
    ); // Recursively trim values in the object
  }
  return obj; // Return unchanged if not a string, array, or object
};
